import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { ProductsAvailabilityTableProps } from './types';
import { getUnitShort } from 'utils/unitMapping';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';

export const ProductsAvailabilityTable = ({
  items,
  getRemainingQuantityForProduct,
}: ProductsAvailabilityTableProps) => {
  const intl = useIntl();

  const filteredItems = useMemo(() => {
    const seenProductIds = new Set<number>();
    return items.filter((item) => {
      if (seenProductIds.has(item.product_id)) return false;
      seenProductIds.add(item.product_id);
      return getRemainingQuantityForProduct(item.product_id) > 0;
    });
  }, [items, getRemainingQuantityForProduct]);

  if (filteredItems.length === 0) return null;

  return (
    <div className="products-availability-list">
      <span className="products-availability-title">
        {intl.formatMessage({ id: 'fulfillment.products_without_delivery' })}:
      </span>
      {filteredItems.map((item) => {
        const qualityMarks = item.product?.qualitymarks?.filter(
          (q, i, arr) =>
            arr.findIndex((x) => x.quality_mark_id === q.quality_mark_id) === i
        );
        return (
          <div key={item.product_id} className="products-availability-item">
            <span>
              {item.product_name}: {getRemainingQuantityForProduct(item.product_id)} {getUnitShort(item.stock_unit)}
            </span>
            {qualityMarks && qualityMarks.length > 0 && (
              <div className="quality-marks">
                {qualityMarks.map((qmark) => (
                  <FallbackImage
                    key={qmark.quality_mark_id}
                    className="quality-mark"
                    src={qmark.quality_mark?.logo || ''}
                    type="notFound"
                    preview={false}
                  />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
